export default __webpack_public_path__ + "static/media/ToyotaType-Book.0650734c.woff2";